export default {
  GET_REGION_ACCESSES_REQUEST: '@@regions/GET_REGION_ACCESSES_REQUEST',
  GET_REGION_ACCESSES_SUCCESS: '@@regions/GET_REGION_ACCESSES_SUCCESS',
  GET_REGION_ACCESSES_ERROR: '@@regions/GET_REGION_ACCESSES_ERROR',
};
